import { ActionType, EntityType, ModuleType } from "../../../queryKeyFactory";
export const coreSettingsKeyFactory = {
  allUtilityService: (): [ModuleType, EntityType] => [
    "onboarding",
    "allUtilityService",
  ],
  systemAdminList: (): [ModuleType, EntityType] => [
    "onboarding",
    "systemAdminList",
  ],
  RolePermissionList: (): [ModuleType, EntityType] => [
    "onboarding",
    "RolePermissionList",
  ],
    ContractList: (): [ModuleType, EntityType] => [
    "onboarding",
    "ContractList",
  ],
  FilteredContractList: (categories, subCategories): [ModuleType, EntityType, "contracts", any, any] => [
    "onboarding",
    "ContractList",
    "contracts",
    categories,
    subCategories
  ],
};
